/* Community submenu JS functions */

export function community_submenu() {

	( ( $ ) => {

		if ( $( '#community-mobile-submenu' ).length <= 0 ) {
			return;
		}

		// Setup the name of the opening button

		let current_item_text = 'Submenu';

		if ( $( '#community-mobile-submenu' ).find( '.current-menu-item' ).length > 0 ) {
			current_item_text = $( '#community-mobile-submenu' ).find( '.current-menu-item:first > .accordion-header > a' ).text();
		} else {
			current_item_text = $( '#community-mobile-submenu' ).find( '.menu-item:first > .accordion-header > a' ).text();
		}

		$( '#community-mobile-submenu > button > span' ).text( current_item_text );


		const first_submenuer = $( '.submenu-on-left:first' );

		// Communities desktop sub-menus next sibling reposition

		const position_community_desktop_submenu = () => {

			if ( 'undefined' == typeof window.COVE.navbar_total_height && first_submenuer.length <= 0 ) {
				return;
			}
	
			if ( $( '#community-desktop-submenu' ).length > 0 && $( '#community-desktop-submenu + div .container' ).length > 0 ) {
				const next_sibling_container_offset = $( '#community-desktop-submenu + div .container' ).offset();
				const next_sibling_container_padding = parseInt( $( '#community-desktop-submenu + div .container' ).css( 'padding-left' ) );
				
				$( '#community-desktop-submenu' ).css( 'margin-left', parseInt( next_sibling_container_offset.left ) + next_sibling_container_padding );
				$( '#community-desktop-submenu' ).css( 'top', `${window.COVE.navbar_total_height}px` );				
			}
		}

		position_community_desktop_submenu();
		$( window ).on( 'resize', position_community_desktop_submenu );

		// Move the submenu and enable it only if there are 'submenu-on-left' elements
		if ( first_submenuer.length > 0 ) {
			$( '#community-desktop-submenu' ).insertBefore( first_submenuer );
			$( '#community-desktop-submenu-calculator' ).insertBefore( first_submenuer );
			$( '#community-desktop-submenu' ).addClass( 'd-lg-block' );	
			first_submenuer.css( 'margin-top', `-${$( '#community-desktop-submenu' ).outerHeight()}px` );	
		}

		// Fix for stickyness misdoings
		const height_check = new ResizeObserver( ( el ) => {
			first_submenuer.css( 'margin-top', `-${$( el[0].target ).outerHeight()}px` );
		} );

		height_check.observe( $( '#community-desktop-submenu' )[0] );

	} )( window.jQuery );
}